import { useLocation } from 'react-router';

export const useIsCommunityRoute = (): boolean => {
  const location = useLocation();

  return location.pathname.includes('/community');
};
